import DynamicPage from '../pages/DynamicPage';
import authRoutes from './auth';
import masterRoutes from './master';
import systemRoutes from './system';
import socialRoutes from './social';
import announcementsRoutes from './announcements';

const routes = [
  ...authRoutes,
  ...masterRoutes,
  ...announcementsRoutes,
  ...socialRoutes,
  ...systemRoutes,
  {
    id: 'not-found',
    component: DynamicPage,
    excludeFromSidebar: true,
  },
];

export default routes;
